import { io } from 'socket.io-client';
import { MEDIA_SERVER_URI } from './constants';
import { generateMediaRoomId } from './utilities';
import { messageService } from './message';

let socket = null;
let appToken = null;

export const connectMediaSocket = async (doctorId, token, type = 'staff') => {
	if (!doctorId || !token) return null;

	if (socket && socket.connected) {
		return socket;
	}

	if (socket) {
		socket.off('connect');
		socket.off('disconnect');
		socket.disconnect();
		socket = null;
	}

	socket = io(MEDIA_SERVER_URI, {
		transports: ['websocket', 'polling'],
		path: '/media/socket.io',
		autoConnect: true,
		query: {
			userId: `${doctorId}`,
			token: token,
			type: 'staff',
		},
	});

	appToken = token;

	socket.on('connect', () => {
		console.log('Staff socket connected:', socket?.id, doctorId, token);
	});

	socket.on('disconnect', reason => {
		console.log('Doctor socket disconnected, reason:', reason);
	});
	return socket;
};

export const disconnectMediaSocket = () => {
	if (socket) {
		// Remove all event listeners before disconnecting
		socket.off('connect');
		socket.off('disconnect');
		socket.off('private-message');
		socket.disconnect();
		socket = null;
	}
};

export const subscribeMediaIO = () => {
	socket.on('private-message', data => {
		console.log(`'private-message' to socket.io`, data);
		messageService.sendMessage({ type: 'private-media-message', data });
	});
};

export const getRecentMediaChats = ({ doctorId }, cb) => {
	if (!socket) {
		return;
	}
	socket.emit('get-recent-doctor-chats', { userId: `${doctorId}`, token: appToken }, res => {
		if (cb) {
			const chats = Array.isArray(res) ? res : [];
			cb(chats);
		}
	});
};

export const getChatHistoryByPatient = ({ doctorId, patientId }, cb) => {
	if (!socket) {
		return;
	}
	socket.emit(
		'join-room',
		{
			roomId: generateMediaRoomId({ patientId, doctorId }),
			userId: `${doctorId}`,
			userType: 'staff',
			roomType: 'chat',
			token: appToken,
		},
		res => {
			if (!res || !res.rtpCapabilities) {
				console.log('Call back failed, Joining room');
			}
		}
	);
	socket.emit('get-chat-history', { currentUserId: `${doctorId}`, withUserId: `${patientId}` }, res => {
		if (cb) {
			const chats = Array.isArray(res) ? res : [];
			cb(chats);
		}
	});
};

export const sendMediaMessage = data => {
	if (!socket) {
		return;
	}
	socket.emit('private-message', { ...data, senderType: 'staff' });
};

export const joinMediaChatRoom = ({ roomId, doctorId, roomType }) => {
	if (!socket) {
		return;
	}
	socket.emit('join-room', { roomId: `${roomId}`, userId: `${doctorId}`, userType: 'staff', roomType, token: appToken }, res => {
		if (!res || !res.rtpCapabilities) {
			console.log('Call back failed, Joining room');
		}
	});
};

export const leaveMediaChatRoom = ({ roomId, doctorId, roomType = 'chat' }) => {
	if (!socket) {
		return;
	}
	socket.emit('leave-room', { roomId: `${roomId}`, userId: `${doctorId}`, roomType }, res => {
		if (res && res.success) {
			console.log('Left media chat room successfully');
		} else {
			console.log('Failed to leave media chat room');
		}
	});
};

export const markMessageAsRead = ({ fromUserId, toUserId }) => {
	if (!socket) {
		return;
	}
	socket.emit('mark-as-read', { fromUserId, toUserId });
};

export const getMediaSocket = () => socket;
export const getAppToken = () => appToken;
